import React, { useContext, useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core';

// store
import { GlobalContext } from '/context';

// actions
import { getMenus } from '/context/actions/menu';

// components
import Header from 'components/layouts/Header';
import NavBar from '/components/layouts/NavBar';
import Footer from '/components/layouts/Footer';

const useStyles = makeStyles(() => ({
    root: {
        width: '100%',
        height: '100%',
    },
}));

export default function HomeLayout({ children }) {
    const classes = useStyles();
    const { state, dispatch } = useContext(GlobalContext);
    const [isMobileNavOpen, setMobileNavOpen] = useState(false);

    useEffect(() => {
        getMenus(dispatch);
    }, []);

    const navbarMenuClose = () => {
        setMobileNavOpen(false);
    };

    return (
        <div>
            <main>
                <div className={classes.root}>
                    <Header
                        onMobileNavOpen={() => setMobileNavOpen(true)}
                        menus={state.menu.list}
                    />
                    {isMobileNavOpen ? (
                        <NavBar
                            onMobileClose={navbarMenuClose}
                            openMobile={isMobileNavOpen}
                            onClose={navbarMenuClose}
                        />
                    ) : (
                        ''
                    )}
                    {children}
                    <Footer />
                </div>
            </main>
        </div>
    );
}
